import React, { useCallback, useEffect } from "react"

import { navigate } from "gatsby-link"
import { Col, Row } from "react-bootstrap"

import CountryCurrencyPerMonth from "./country-currency-pm"
import debounce from "../../utils/debounce"
import InputBox from "../input/wdn-input-box"
import {
  formatSalaryWithComma,
  formatSalaryWithoutComma,
} from "../../utils/formatSalary"

const SalaryMinMax = ({
  minSalaryBar,
  minSalary,
  maxSalary,
  country,
  setMinSalary,
  setMaxSalary,
  errors,
  setErrors,
  search,
  encodeQueryData,
  showExpectedSalary,
}) => {
  const searchWithMaxSalaryChange = (value, params, minSalaryBar) => {
    setErrors({})
    if (
      Number(params.minSalary) >= Number(minSalaryBar) &&
      value > Number(params.minSalary)
    ) {
      setMaxSalary(value)

      if (value !== "") {
        params.maxSalary = formatSalaryWithoutComma(params.maxSalary)
        const url = encodeQueryData(params)
        navigate("/search-candidates?" + url)
      } else {
        delete params["maxSalary"]
        const url = encodeQueryData(params)
        setMaxSalary("")
        navigate("/search-candidates?" + url)
      }
    } else if (!params.maxSalary) {
      delete params["maxSalary"]
      const url = encodeQueryData(params)
      setMaxSalary("")
      navigate("/search-candidates?" + url)
    } else if (Number(params.minSalary) >= value) {
      setErrors({ msg: `Max salary should be more than min salary`, max: "a" })
      const max = document.getElementById("maxSalary")
      max.value = ""
    } else {
      setErrors({ min: "Bad value", max: "Bad value" })
    }
  }
  const searchWithMinSalaryChange = (value, params, minSalaryBar) => {
    setErrors({})
    if (
      Number(minSalaryBar) <= value &&
      (!params.maxSalary || Number(params.maxSalary) > value)
    ) {
      setMinSalary(value)
      if (!params.maxSalary) delete params["maxSalary"]
      params.minSalary = formatSalaryWithoutComma(params.minSalary)
      const url = encodeQueryData(params)
      navigate("/search-candidates?" + url)
    } else if (Number(minSalaryBar) > value) {
      setErrors({
        msg: `Min salary should not be less than ${minSalaryBar}`,
        min: "a",
      })
    } else if (params.maxSalary && params.maxSalary <= value) {
      setErrors({ msg: `Max salary should be more than min salary`, max: "a" })
      const min = document.getElementById("minSalary")
      min.value = minSalaryBar
    } else {
      setErrors({ min: "Bad value", max: "Bad value" })
    }
  }

  const handleMinSalaryChange = value => {
    const params = {
      ...search,
      minSalary: value.target.value,
      maxSalary: maxSalary || null,
    }
    const min = document.getElementById("minSalary")
    const val = formatSalaryWithoutComma(value.target.value)

    min.value = formatSalaryWithComma(Number(val || 0))
    setMaxSalary(params.maxSalary)
    debouncedMinSalaryChange(
      formatSalaryWithoutComma(value.target.value),
      params,
      minSalaryBar
    )
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debouncedMaxSalaryChange = useCallback(
    debounce(
      (value, params, minSalaryBar) =>
        searchWithMaxSalaryChange(value, params, minSalaryBar),
      1000
    ),
    [searchWithMaxSalaryChange]
  )

  const handleMaxSalaryChange = value => {
    const params = {
      ...search,
      maxSalary: value.target.value,
      minSalary: minSalary || minSalaryBar,
    }
    const max = document.getElementById("maxSalary")
    const val = formatSalaryWithoutComma(value.target.value)
    max.value = formatSalaryWithComma(val)
    setMinSalary(params.minSalary)
    debouncedMaxSalaryChange(
      formatSalaryWithoutComma(value.target.value),
      params,
      minSalaryBar
    )
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debouncedMinSalaryChange = useCallback(
    debounce(
      (value, params, minSalaryBar) =>
        searchWithMinSalaryChange(value, params, minSalaryBar),
      1000
    ),
    [searchWithMinSalaryChange]
  )

  const onFocus = () => {
    setErrors({})
  }

  useEffect(() => {}, [minSalaryBar, country])
  return (
    showExpectedSalary && (
      <Col className="px-4">
        <Row className="mb-3">
          {!!country && <CountryCurrencyPerMonth country={country} />}
          <Col className="pl-0">
            <InputBox
              type="string"
              name="minSalary"
              onFocus={onFocus}
              id="minSalary"
              min={minSalaryBar}
              onChange={handleMinSalaryChange}
              styles={`${
                errors.min && "error"
              } rounded-border padding-5px allow-focus outline-faded`}
              placeholder="Min Salary"
            />
          </Col>
          <Col className="pr-0">
            <InputBox
              type="string"
              id="maxSalary"
              onFocus={onFocus}
              min={minSalaryBar + 1}
              name="maxSalary"
              onChange={handleMaxSalaryChange}
              placeholder="Max Salary"
              styles={`${
                errors.max && "error"
              } rounded-border padding-5px allow-focus outline-faded`}
            />
          </Col>
        </Row>
        {(errors.min || errors.max) && errors.msg && (
          <div className="mt-2">
            <span className="text-danger">{errors.msg}</span>
          </div>
        )}
      </Col>
    )
  )
}

export default SalaryMinMax
